export const getUserTimeZone = () => {
      
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  
};
